import { queryOptions } from "@tanstack/react-query";
import { axiosInstance } from "./axios";

export interface FeatureFlagResponse {
    featureName: string;
    isNew: boolean;
}

export const featureFlagsApi = {
    getFeatureFlags: async (): Promise<FeatureFlagResponse[]> => {
        const response = await axiosInstance.get<FeatureFlagResponse[]>("/feature-flags");
        return response.data;
    }
};



export const featureFlagsQueryOptions = queryOptions({
    queryKey: ["featureFlags"],
    queryFn: featureFlagsApi.getFeatureFlags,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
});